/**
 * Stato nel negozio (WooCommerce / Shopify) degli ordini del motore in un elenco: v_all_orders non lo porta,
 * si legge da orders in una query sola. Gli ordini della vecchia integrazione WooCommerce
 * (source_table 'woocommerce_orders') hanno gia' lo stato di WordPress in `status`: vedi storeBadgesFor.
 */
import { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import { isStoreChannel } from '../utils/unifiedOrderQuery';
import type { UnifiedOrder } from '../types/orders';
import { storeStatusBadges, type StoreStatusBadge } from './storeOrderStatus';

export type StoreRawStatuses = Record<string, { fin: string | null; ful: string | null }>;

export function useStoreOrderStatuses(orders: readonly UnifiedOrder[]): StoreRawStatuses {
  const [map, setMap] = useState<StoreRawStatuses>({});
  useEffect(() => {
    const ids = orders.filter(o => isStoreChannel(o.channel) && o.source_table !== 'woocommerce_orders').map(o => o.id);
    if (ids.length === 0) { setMap({}); return; }
    let cancelled = false;
    supabase
      .from('orders')
      .select('id, external_financial_status, external_fulfillment_status')
      .in('id', ids)
      .then(({ data, error }) => {
        if (cancelled || error || !data) return;
        const m: StoreRawStatuses = {};
        for (const r of data) m[r.id] = { fin: r.external_financial_status, ful: r.external_fulfillment_status };
        setMap(m);
      });
    return () => { cancelled = true; };
  }, [orders]);
  return map;
}

/** Etichette del negozio per una riga dell'elenco; null = ordine manuale (stato di Flusia). */
export function storeBadgesFor(order: UnifiedOrder, raw: StoreRawStatuses): StoreStatusBadge[] | null {
  const legacy = order.source_table === 'woocommerce_orders';
  const r = raw[order.id];
  return storeStatusBadges({
    channel: order.channel, status: order.status,
    rawFinancial: legacy ? order.status : r?.fin, rawFulfillment: legacy ? null : r?.ful,
  });
}
